import '#components/products-selector'

document.addEventListener('DOMContentLoaded', () => {
  const inputEls: NodeListOf<HTMLInputElement> = document.querySelectorAll('[data-wholesale-form] input')
  const errorEl = document.querySelector('[data-wholesale-form-errors]')
  const buildErrors = () => {
    if (!errorEl) return

    let html = ''

    inputEls.forEach((inputEl) => {
      const label = inputEl.getAttribute('data-label')

      if (!inputEl.validity.valid && label) {
        html += `<div class="tw-flex"><span class="tw-w-5 tw-text-center">&#8226;</span><span>Select ${label}</span></div>`
      }
    })
    errorEl.innerHTML = html
  }

  if (inputEls.length) {
    inputEls.forEach((inputEl) => {
      ;['invalid', 'input'].forEach((eventName) => {
        inputEl.addEventListener(eventName, () => {
          buildErrors()
        })
      })
    })
  }
})
